import { IDataTableColumn, parseColumnFlexWeight, parseColumnWidth } from '@srm/ui/data-table';
import DisplayField from '@molecules/DisplayField/DisplayField';
import { IAddressBookData } from '@models/addressbook/IAddressBookData';
import { IAbookTabColumn } from '@models/Forms/IForms';
import { ValueType } from '@srm/ui/types/ValueType';

/** Значение колонки вкладки: свои поля лежат в строке, атрибуты — в `attributes`. */
export const abookValue = (row: IAddressBookData, column: IAbookTabColumn): unknown =>
    column.isAttribute
        ? (row as unknown as { attributes?: Record<string, unknown> }).attributes?.[column.key]
        : (row as unknown as Record<string, unknown>)[column.key];

// Ширина колонки вкладки приходит строкой («200», «10%»): px — точный трек,
// проценты — fr-вес гибкого трека (единый разбор атома, как в таблицах форм)

/**
 * Колонки списка адресной книги по описанию вкладки.
 *
 * Логические поля (например «В отпуске») приходят настоящим boolean — рисуем их
 * фирменным чекбоксом через `DisplayField`, а не текстом «true».
 *
 * `attributes.<key>` — та же адресация, что понимает бэкенд в фильтрах и
 * сортировке, поэтому имя поля колонки совпадает с ключом запроса.
 */
export function buildAbookColumns(
    columns: IAbookTabColumn[] | undefined,
    options: { filterableOnly?: (column: IAbookTabColumn) => boolean } = {},
): IDataTableColumn<IAddressBookData>[] {
    return (columns ?? []).map((column) => {
        const width = parseColumnWidth(column.width);
        const flexWeight = parseColumnFlexWeight(column.width);
        const allowFiltering = options.filterableOnly
            ? options.filterableOnly(column)
            : column.allowFiltering !== false;
        return {
            field: column.isAttribute ? `attributes.${column.key}` : column.key,
            header: column.name,
            dataType: ValueType.Text,
            accessor: (row) => abookValue(row, column),
            cellText: (row) => {
                const value = abookValue(row, column);
                return typeof value === 'boolean' ? (value ? 'Да' : 'Нет') : String(value ?? '');
            },
            width,
            flexWeight,
            widthHint: !width && !flexWeight,
            allowSorting: column.allowSort !== false,
            allowFiltering,
            render: (row) => {
                const value = abookValue(row, column);
                return typeof value === 'boolean' ? (
                    <DisplayField type={ValueType.Boolean} value={value ? '1' : '0'} />
                ) : (
                    <>{String(value ?? '')}</>
                );
            },
        };
    });
}
